// Release Switch Toggles: should not be used directly
// @see getReleaseSwitchToggleCookieName util
export const RELEASE_SWITCH_TOGGLE = 'release-switch'
export const RELEASE_SWITCH_TOGGLE_AT = 'release-switch-at'

// Release Toggles
export const RELEASE_TOGGLE_SAE_ONLY = 'sae-only'
export const RELEASE_TOGGLE_MARKETPLACE = 'marketplace'
export const RELEASE_TOGGLE_CART_CTA_DELAYED = 'cart-cta-delayed'
export const RELEASE_TOGGLE_ERX = 'erx'
export const RELEASE_TOGGLE_NOW = 'now'
export const RELEASE_TOGGLE_MP_CROSS_SELL = 'mp-cross-sell'
export const RELEASE_TOGGLE_VARIANT_ATTTRIBUTES_ENABLED = 'enabled'
export const RELEASE_TOGGLE_VARIANT_ATTRIBUTES = 'variant-attributes'
export const RELEASE_TOGGLE_HOME_ONE = 'home-one'
export const RELEASE_TOGGLE_HOME_ONE_CMS = 'h1-cms'
export const REBRANDING_IT_TOGGLE = 'rebranding-it'
export const REBRANDING_COM_TOGGLE = 'rebranding-com'
export const ERX_ADYEN_TOGGLE = 'erx-adyen'
export const ERX_ADYEN_MP_TOGGLE = 'erx-adyen-mp'
export const ERX_NOW_TOGGLE = 'erx-now'
export const APPLE_PAY_TOGGLE = 'wstra-2462'
export const CPH_MAX_DOSAGE_TOGGLE = 'wstra-5851'
export const HOME_ONE_ACCOUNT = 'wsssh-2348'
export const WELCOME_PAGE_TOGGLE = 'wscr-2386'

// Experiments
export const AD_FLYOUT_BANNER = 'cro-1333'
export const XSELL_NEW_LAYOUT = 'xsell-new-layout'
export const ODS_CLIENT_FLOW = 'ods-client-flow'
export const NEW_HEADER = 'header'
export const CSW_PRODUCT_TITLE = 'cro-780'
export const NEW_CDN = 'cro-1881'
export const SERP_NOW_PUSH = 'cro-121'
export const SERP_LOAD_MORE = 'cro-179'
export const VARIANT_ATTRIBUTES = 'variant-attributes'
export const NEW_CSW = 'cro-513'
export const EXTENDED_SEARCHBOX_RESULTS = 'cro-1244'
export const TOP_DEALS_LABEL = 'cro-1073'
export const CTA_BUTTON_ON_ALL_CSW = 'cro-2052'
export const CART_CSW_THREE_PRODUCTS = 'cro-2119'
export const SPECIAL_SALE_OFFERS_MODAL = 'cro-1905'
export const CHANGE_GTM_SCRIPT_COM = 'cro-2468'
export const CHANGE_GTM_SCRIPT_FR = 'cro-3124'
export const CROSSSELL_LAYOUT = 'cro-1942'
export const NOW_HOMEPAGE_GB_FUNCTIONALITY = 'wstra-5032'
export const NOW_SERP_GB_FUNCTIONALITY = 'wstra-5031'
export const NOW_CATEGORY_GB_FUNCTIONALITY = 'wstra-5033'
export const CART_MAX_DOSAGE = 'wstra-6126'
export const SHIPPING_DELAY_NOTIFICATION = 'wstra-6359'
export const EXPERIMENT_NAME_MP_DELIVERY_INFO_CART = 'wsawa-5357'

export const ORDER_HELP_MODAL_LINK = 'wsssh-2747'

export const SINGLE_ITEM_CANCELLATION = 'wstra-8615'

export const ALGOLIA_SPLIT = 'alg'

// ad-server experiments' name
export const AD_SERVER = 'ad-server'
export const AD_SERVER_SEARCH_PRODUCT = 'ad-se'
export const AD_SERVER_CROSSSELL_PRODUCT = 'ad-xs'
export const AD_SERVER_BANNER = 'ad-ba'

export const HIDE_VIDEO_CONSULTATION = 'wsssh-1561'
export const RETAIL_MEDIA_CROSS_SELL_SERVICE = 'rmadt-954'
export const RETAIL_MEDIA_SEARCH_BOOSTER = 'rmadt-1506'
export const RETAIL_MEDIA_ALGOLIA_WRAPPER = 'rmadt-1819'
export const TOTAAL_KORTING_AB_TEST = 'wscnl-5650'

// test different pricing strategies
export const DIFFERENT_PRICING_STRATEGY = 'wsawa-2829'
export const DIRECT_CHANNEL = 'direct'

export const ONE_TIME_PASSWORD_FAKE_DOOR_TEST = 'wscnl-6729-fake-door'

export const SHOW_CONTACT_INFORMATION = 'wscnl-7196'

export const SHOW_RATEPAY_FOR_ALL_ORDERS = 'wscnl-7469'
